exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container--overview {\n  margin-left: 15px;\n}\n\n.row-flex {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0 10px;\n  border-bottom: 1px solid rgba(0, 115, 180, 0.25);\n}\n\n.view {\n  float: right;\n  font-size: 24px;\n  padding: 10px 0;\n}\n\n.view.grid {\n  margin-right: 10px;\n}\n\n.view .fa {\n  color: rgba(0, 137, 196, 0.5);\n}\n\n.view .fa.active {\n  color: #0089c4;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/item-overview/item-overview.component.scss
// module id = ../../../../../src/app/components/item-overview/item-overview.component.scss
// module chunks = main